import PropTypes from "prop-types";
import { SFUseStyled, SFStack } from "@sf-core";

const { styled } = SFUseStyled();

const RankStyled = styled("div")(({ theme }) => ({
  color: theme.palette.grey300.main,
  fontSize: 12,
  fontEeight: 300,
  lineHeight: "24px",
  borderRadius: 6,
  background: "rgba(255, 255, 255, 0.06)",
  display: "flex",
  width: 27,
  height: 27,
  marginTop: 12,
  justifyContent: "center",
  alignItems: "flex-start",
}));

const SFRankRenderer = ({ value }) => {
  return (
    <SFStack direction="row" sx={{ height: "100%" }}>
      <RankStyled>{value}</RankStyled>
    </SFStack>
  );
};

SFRankRenderer.propTypes = {
  value: PropTypes.any,
};

export default SFRankRenderer;
